import { Link } from "react-router-dom";

//This page will be displayed if a link is broken

const NotFound = () => {

    document.title = "Page Not Found";
    return (  
        <div className="notfound">
            <h2>Sorry,</h2>
            <p>Couldn't find that!</p> 
            <br />
            <Link to="/">Return Home</Link>
        </div>
    );
}

export default NotFound;